
import React from 'react';
import './TableCategories.scss';
import { idSubCategoryLoad, getIdSelectedCategory, openInputFormsForCategories, openDeleteInputForms  } from '../../../../adminSlice.js';

export default class TableCategories extends React.Component {
    constructor(props) {
        super(props);

        this.onGetSubCategory = this.onGetSubCategory.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

   //GET SUBCATEGORY BY ID
onGetSubCategory(e) {
    const { dispatch } = this.props;
    //console.log(this.props.adminState.dataQuizes);
    const id= e.target.value ;
 
    console.log(id);
    const item = {
        id: id,
        userId: this.props.userId
    }
    dispatch(idSubCategoryLoad(item));
    dispatch(getIdSelectedCategory(id));
  
}
onEdit(e) {
    const { dispatch } = this.props;

    const id = e.target.value;
    console.log(id);
    dispatch(openInputFormsForCategories(id));

}
onDelete(e) {
    const { dispatch } = this.props;

    const id = e.target.value;
    console.log(id);
    dispatch(openDeleteInputForms(id));

}

   renderTable() {
    let  data =  this.props.data;

    return (
        data.map(item => {
           // console.log(item.id + " " + item.label);

            return(
                
                    <tr key={item.id}>
                        <td>{item.id}</td>
                        <td><button className='bigbtn'                      
                         onClick={this.onGetSubCategory}
                         value={item.id}
                         >{item.label}</button>
                         <div className='edit'>
                            <button className='smallbtnEdit' value={item.id} onClick={this.onEdit}>{/*<i className="fas fa-marker"></i>Ed*/}</button>
                            <button className='smallbtnDelete' value={item.id} onClick={this.onDelete}></button>
                         </div>
                        </td>
                    </tr>
                    
                

                )
            })
        )    
   }
   
    render() {

        return(
            <div className="TableCategories">
                
                <table>
                    {/*<caption>Список категорий</caption>*/}
                    <thead>
                        <tr>
                            <th>№</th>
                            <th>Hазвание </th>
                        </tr>
                        
                    </thead>
                    <tbody>
                    {this.renderTable()}
                   
                    
                    </tbody>

                </table>
                
            </div>
        )
    }
}